import { NgModule, InjectionToken } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActionReducerMap, StoreModule } from '@ngrx/store';
import { TranslocoModule } from '@jsverse/transloco';
import { EffectsModule } from '@ngrx/effects';

import { GlobalPipesModule } from '@app/pipes/global-pipes.module';
import { HomeItemDetailFacade } from '@home-item-detail/home-item-detail.facade';
import { HomeItemDetailState, homeItemDetailName } from '@home-item-detail/store/state/home-item-detail.state';
import { HomeItemDetailService } from '@home-item-detail/services/home-item-detail.service';
import { HomeItemDetailStoreEffects } from '@home-item-detail/store/effects/home-item-detail.effects';
import { HotelItemDetailRoutingModule } from '@home-item-detail/home-item-detail-routing.module';
import { HomeItemComponent } from '@home-item-detail/components/home-item/home-item.component';
import { homeItemDetailRootReducer } from '@home-item-detail/store/reducers';
import { HomeItemPlaceholderComponent } from '@home-item-detail/components/home-item-placeholder/home-item-placeholder.component';
import { SearchBarModule } from '@search-bar/search-bar.module';
import { SwipeUpModule } from '@ux/components/swipe-up/swipe-up.module';
import { ImageModule } from '@ux/components/image/image.module';
import { HomeSectionsModule } from '@shared/home-sections/home-sections.module';
import { HomeItemHeaderComponent } from '@home-item-detail/components/home-item-header/home-item-header.component';
import { HomeItemLinkComponent } from '@home-item-detail/components/home-item-link/home-item-link.component';
import { HomeItemLinksComponent } from '@home-item-detail/components/home-item-links/home-item-links.component';
import { HotelSearchModule } from '@hotels/hotel-search/hotel-search.module';
import { GalleryDestinationModule } from '@ux/components/gallery-destination/gallery-destination.module';
import {
  HomeItemSearchDesktopComponent
} from '@home-item-detail/components/home-item-search-desktop/home-item-search-desktop.component';
import { AutoSearchModule } from '@autos/auto-search/auto-search.module';
import { PackagesSearchBarModule } from '@packages/packages-search-bar/packages-search-bar.module';
import { TravelLoaderComponent } from '@ux/components/travel-loader/travel-loader.component';
import { NoModuleAvailableModule } from '@shared/no-module-available/no-module-available.module';
import { ChipActionDsComponent } from '@design-system/components/molecules/chip-action/chip-action.component';
import { ActivitiesSearchBarModule } from '@activities/activities-search-bar/activities-search-bar.module';
import { TypographyDsComponent } from '@design-system/components/atoms/typography/typography.component';
import { MenuLinkDsComponent } from '@design-system/components/molecules/menu-link/menu-link.component';

export const FEATURE_REDUCER_TOKEN = new InjectionToken<
  ActionReducerMap<HomeItemDetailState>
>('Feature Reducers');

@NgModule({
  declarations: [
    HomeItemComponent,
    HomeItemHeaderComponent,
    HomeItemLinkComponent,
    HomeItemLinksComponent,
    HomeItemSearchDesktopComponent
  ],
  imports: [
    CommonModule,
    GlobalPipesModule,
    TranslocoModule,
    HotelItemDetailRoutingModule,
    SearchBarModule,
    SwipeUpModule,
    StoreModule.forFeature(homeItemDetailName, FEATURE_REDUCER_TOKEN),
    EffectsModule.forFeature([HomeItemDetailStoreEffects]),
    ImageModule,
    HomeSectionsModule,
    HotelSearchModule,
    GalleryDestinationModule,
    AutoSearchModule,
    PackagesSearchBarModule,
    ChipActionDsComponent,
    NoModuleAvailableModule,
    ActivitiesSearchBarModule,
    TypographyDsComponent,
    MenuLinkDsComponent,
    TravelLoaderComponent,
    HomeItemPlaceholderComponent,
  ],
  providers: [
    HomeItemDetailFacade,
    {
      provide: FEATURE_REDUCER_TOKEN,
      useValue: homeItemDetailRootReducer,
    },
    HomeItemDetailService
  ]
})
export class HomeItemDetailModule { }
